import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type ResponseGetPsychologist = {
  name?: string;
  img?: string;
  email: string;
};

export const getPsychologist = async () => {
  const response = await axios.get(`${rootUrl}/psychologist/profile`, {
    params: {
      token: getCookies('auth'),
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
